<section 
  class="content-layout" 
  [brightsideWebFb]="{ event_name: 'survey_abandoned' }"  
>
  <bw-action-article-legacy>
    <div content-section>
      <div class="flex-column mb-sm">
        <div class="align-left">
          <img src="../assets/survey-abandoned.svg" alt="survey_abandoned" class="mb-md" />
          <p title-medium class="mb-sm">{{ 'SURVEY_ABANDONED_TITLE' | translate }}</p>
          <typography-legacy text-large-regular color="var(--secondary-text)">
            <p class="left" style="max-width: 432px;">
              {{ 'SURVEY_ABANDONED_DESC' | translate }}
            </p>
          </typography-legacy>
        </div>
      </div>
    </div>

    <div footer-actions>
      <button        
        bw-button-legacy
        type="submit"
        [brightsideWebFb]="{ event_name: 'survey_abandoned' }"
        (click)="handleSurveyAbandonedDone()"
      >
        {{ 'SURVEY_ABANDONED_CTA' | translate }}
      </button>
    </div>
  </bw-action-article-legacy>
</section>
